export default {
  title: 'Renombrar oferta',
  subtitle: 'Introduzca un nuevo nombre para su oferta (máximo 40 caracteres)',
  toasts: {
    success: 'Oferta renombrada correctamente',
    error: 'Error al renombrar la oferta',
  },
  buttons: {
    rename: 'Renombrar',
  },
  form: {
    title: {
      label: 'Nombre de la oferta',
      placeholder: 'Introduzca el nombre de la oferta',
    },
  },
};
